module.exports = __webpack_public_path__ + "static/img/4.0256492.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/4.png
// module id = weiN
// module chunks = 0